import { Reveal, Kicker } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { MapPin, Mail } from "lucide-react";

const BENCH_IMG =
  "https://images.unsplash.com/photo-1532094349884-543bc11b234d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5JTIwbWluZXJhbCUyMHNjaWVuY2V8ZW58MHx8fHwxNzg4MTM2MzM0fDA&ixlib=rb-4.1.0&q=85";

export default function AboutContact() {
  return (
    <div data-testid="about-contact-page">
      <section className="hero-grid pt-32 lg:pt-40 pb-16 lg:pb-20 border-b border-line">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal y={16}>
            <Kicker index="§5">About & Contact</Kicker>
            <h1 className="mt-6 font-headline font-semibold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.06] max-w-4xl">
              Built in Madison, Wisconsin.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-24" data-testid="about-leadership">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <Reveal>
              <Kicker>Leadership</Kicker>
              <h2 className="mt-5 font-headline font-semibold tracking-tight text-ink text-2xl sm:text-3xl lg:text-4xl">
                Amadeus Benitez
              </h2>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.2em] text-pine">
                Owner & Inventor
              </p>
              <p className="mt-6 text-sm sm:text-base text-smoke leading-relaxed max-w-2xl">
                Amadeus Benitez is the owner of Chocolate Detox LLC and the inventor of its
                proprietary adsorbent active and the trade-secret process behind it. He leads
                development, supply and licensing from Madison, Wisconsin · working directly with
                manufacturers, licensees and distributors evaluating the active for their markets.
              </p>
              <div className="mt-10 grid sm:grid-cols-2 gap-px bg-line border border-line max-w-2xl">
                <div className="bg-white p-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint flex items-center gap-2">
                    <MapPin size={12} /> Registered office
                  </p>
                  <p className="mt-3 text-sm text-ink font-medium">Chocolate Detox LLC</p>
                  <p className="text-sm text-smoke">Madison, Wisconsin, USA</p>
                </div>
                <div className="bg-white p-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint flex items-center gap-2">
                    <Mail size={12} /> Direct email
                  </p>
                  <a
                    href="mailto:amadeus@chocolatedetoxfordogs.com"
                    data-testid="about-email-link"
                    className="mt-3 inline-block text-sm text-pine hover:text-pinehover font-medium break-all transition-colors duration-200"
                  >
                    amadeus@chocolatedetoxfordogs.com
                  </a>
                </div>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.12}>
              <div className="border border-line bg-white p-2">
                <div className="overflow-hidden aspect-[4/3]">
                  <img src={BENCH_IMG} alt="Analytical measurement and spectroscopy validation in laboratory" className="img-clinical w-full h-full object-cover" />
                </div>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint px-1 py-2.5">
                  Fig. 03 · Analytical bench, Madison WI
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-white border-t border-line" data-testid="contact-form-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Kicker>Contact</Kicker>
              <h2 className="mt-5 font-headline font-semibold tracking-tight text-ink text-2xl sm:text-3xl lg:text-4xl leading-tight">
                Write to us directly.
              </h2>
              <p className="mt-5 text-sm sm:text-base text-smoke leading-relaxed max-w-md">
                For supply, licensing, technical or press enquiries. Messages route directly to
                our Madison office. For territory and supply discussions, please use the
                partnership enquiry form.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.12}>
              <div className="border border-line bg-paper p-6 sm:p-10">
                <LeadForm variant="contact" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
